module.exports = __webpack_public_path__ + "images/3b2229067d712ad6fe247919cb7a9e3a0.svg";